<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading
                :active.sync="isLoading"
                :is-full-page="fullPage"
            ></loading>
        </div>

        <breadcrumb
            :page="$t('form.student.graduationImportList')"
        ></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert
                    v-model="alert"
                    :variant="alertClass"
                    dismissible
                    fade
                    >{{ alertMessage }}</b-alert
                >

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">
                            {{ $t("form.student.graduationImportList") }}
                        </h3>

                        <button
                            v-show="graduationList.length > 1 && incorrectRecords.length === 0"
                            type="submit"
                            class="btn btn-primary float-right"
                            @click="acceptStudentFile"
                        >
                            {{ $t("form.student.import") }}
                            {{ graduationList.length }}
                            {{ $t("form.student.record") }}
                            <span v-show="graduationList.length > 1 && incorrectRecords.length === 0">(s)</span>
                        </button>

                        <button
                            type="submit"
                            class="btn btn-danger float-right mr-3"
                            @click="rejectStudentFile"
                        >
                            {{ $t("button.cancel") }}
                        </button>
                    </div>

                    <div class="card-body">
                        <!-- table  -->
                        <div class="card-body table-responsive p-0">
                            <table
                                class="table table-hover"
                                v-if="
                                    graduationList.length > 0 ||
                                        incorrectRecords.length > 0
                                "
                            >
                                <thead>
                                    <tr class="header">
                                        <th>
                                            {{
                                                $t("form.student.studentNumber")
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    "form.student.transcriptName"
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.dateOfBirth") }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.birthPlace") }}
                                        </th>
                                        <th>
                                            {{
                                                $t("form.student.birthCountry")
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t("form.student.graduateDate")
                                            }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.graduate") }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.partnerCode") }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    "form.student.CampusLocation"
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.program") }}
                                            {{ $t("form.student.title") }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.programCode") }}
                                        </th>
                                        <th>
                                            {{ $t("form.student.programType") }}
                                        </th>
                                        <th>
                                            {{
                                                $t("form.student.academicYear")
                                            }}
                                        </th>
                                        <th>{{ $t("form.student.error") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        :v-if="incorrectRecords.length > 0"
                                        v-for="(record,
                                        index) in incorrectRecords"
                                        v-bind:key="index"
                                    >
                                        <td
                                            style="color:red"
                                            v-for="(td, tdindex) in record"
                                            v-bind:key="'td' + tdindex"
                                        >
                                            {{ td }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-for="(graduation,
                                        index) in graduationList"
                                        v-bind:key="
                                            index + incorrectRecords.length
                                        "
                                    >
                                        <td
                                            v-for="(td, tdindex) in graduation"
                                            v-bind:key="'td' + tdindex"
                                        >
                                            {{ td }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <p class="p-3 m-0" v-else>{{ $t("noRecord") }}</p>
                        </div>
                        <!-- table end  -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["permissions", "dateFormat"],

    data() {
        return {
            graduationList: [],
            incorrectRecords: [],
            filePath: "",
            alert: false,
            alertClass: "",
            alertMessage: "",
            isLoading: false,
            fullPage: true,
            header: true,
            delimiter: true,
            qualifier: false
        };
    },

    mounted() {
        if (!this.permissions.createImportGraduations) {
            this.$router.push("/");
        }

        this.setLocalVariableData();
    },

    methods: {
        setLocalVariableData() {
            let list = window.localStorage.getItem("graduations");
            if (list) {
                this.incorrectRecords = JSON.parse(list).incorrectRecords;
                this.graduationList = JSON.parse(list).correctRecords;

                this.filePath = localStorage.getItem("path");
                this.qualifier = localStorage.getItem("qualifier");

                let msg = "";

                if (this.incorrectRecords.length > 0) {
                    msg =
                        this.incorrectRecords.length +
                        "records are having incorrect data.";
                } else if (this.graduationList.length > 0) {
                    msg =
                        this.graduationList.length +
                        "records imported successfully.";
                }

                window.localStorage.setItem("dataSaved", msg);
            }
        },

        rejectStudentFile() {
            this.isLoading = true;
            axios
                .post("/api/students/cancel-import", { path: this.filePath })
                .then(resp => {
                    this.isLoading = false;
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$router.go(-1);
                });
        },

        acceptStudentFile() {
            let formData = new FormData();
            let vm = this;
            formData.append("graduations", JSON.stringify(this.graduationList));
            formData.append("path", this.filePath);
            formData.append("qualifier", this.qualifier ? 1 : 0);
            formData.append("signature", this.signature);
            this.isLoading = true;

            axios
                .post("/api/graduations/save", formData)
                .then(response => {
                    this.isLoading = false;
                    vm.$router.push("/graduation-import");
                })
                .catch(error => {
                    this.showAlert(error, "danger");
                    this.isLoading = false;
                });

            this.studentList = [];
            this.dublicateList = [];
            localStorage.setItem("graduations", JSON.stringify([]));
            // localStorage.setItem('dublicates' ,JSON.stringify([]))
            window.localStorage.removeItem("qualifier");
            window.localStorage.removeItem("signature");
        },

        showAlert(msg, cls = "success") {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        }
    }
};
</script>
